import { render, staticRenderFns } from "./FundamentalFormResult.vue?vue&type=template&id=a828fb1a&scoped=true&"
import script from "./FundamentalFormResult.vue?vue&type=script&lang=js&"
export * from "./FundamentalFormResult.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalFormResult.vue?vue&type=style&index=0&id=a828fb1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a828fb1a",
  null
  
)

export default component.exports